export const NOT_FOUND = 'NOT_FOUND'; // eslint-disable-line import/prefer-default-export
